import {
    Disclosure as HeadlessDisclosure,
    DisclosureButton,
    DisclosurePanel,
} from '@headlessui/react'
import { FaChevronDown } from 'react-icons/fa'

export default function Disclosure({ items, className = '' }) {
    return (
        <div
            className={`w-full max-w-xl rounded-xl border border-gray-200 bg-white divide-y ${className}`}
        >
            {items.map((item, index) => (
                <HeadlessDisclosure key={index} defaultOpen={item.defaultOpen}>
                    {({ open }) => (
                        <div className='px-4 py-4'>
                            <DisclosureButton className='flex items-center justify-between w-full text-left group'>
                                <span className='text-sm font-medium text-gray-800 group-hover:text-gray-600'>
                                    {item.question}
                                </span>
                                <FaChevronDown
                                    className={`text-gray-400 transition-transform duration-200 size-5 ${
                                        open ? 'rotate-180' : ''
                                    }`}
                                />
                            </DisclosureButton>
                            <DisclosurePanel className='mt-2 text-sm text-gray-600'>
                                {item.answer}
                            </DisclosurePanel>
                        </div>
                    )}
                </HeadlessDisclosure>
            ))}
        </div>
    )
}
